<div>
    <div class="header-content-main flex justify-end py1">
        <div class="flex self-center m-r4 white-text">
            <menu class="m-y0"></menu>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
